import { css } from '@/styled-system/css';

export const priceOnlyContainerStyles = css.raw({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  order: { base: -1, lg: 1 },
  justifyContent: { lg: 'flex-end' },
  marginRight: { lg: '400' },
});

export const mobileOnlyVerticalDividerStyles = css.raw({
  backgroundColor: 'border.subtle',
  display: 'flex',
  height: '10px',
  margin: '0 {spacing.200}',
  width: '1px',

  lg: {
    display: 'none',
  },
});
